export function useCanvaLinkBuilder(flavor) {
  const base = flavor === "production" ? "https://canva.com/content-partner" : "https://canva-dev.com/content-partner";

  const canvaVariants = {
    A: "DEFAULT",
    B: "WITH_DOCTYPE",
    C: "WITH_DOCTYPE_AND_BRANDING",
    IA: "INLINE_EDITOR_DEFAULT",
  };

  const utmPrefix = "REMOVE_BG_TO_CANVA";

  const buildUrl = (image: string, variant: string | undefined, doctype: string | undefined = undefined) => {
    const url = new URL(base);

    url.searchParams.append("image-url", image);
    if (doctype) url.searchParams.append("type", doctype);
    if (variant) {
      const variantParam = canvaVariants[variant.toUpperCase()];
      url.searchParams.append("variant", variantParam);
      url.searchParams.append("utm_campaign", `${utmPrefix}_${variantParam}`);
    }

    return url.toString();
  };

  return {
    buildUrl,
  };
}
